{
  "name": "31edo (in Vicentino Notation, 1555)",
  "description": "31-tone equal tempered scale consisting of 31 sonically equal divisions per octave. Similar to 1/4-Syntonic Comma meantone, the system was first described by Lemme Rossi in 1666, although Vicentino effectively proposed it in 1555. Using a notation invented by Nicola Vicentino.",
  "scale": [
    "1\\31",
    "2\\31",
    "3\\31",
    "4\\31",
    "5\\31",
    "6\\31",
    "7\\31",
    "8\\31",
    "9\\31",
    "10\\31",
    "11\\31",
    "12\\31",
    "13\\31",
    "14\\31",
    "15\\31",
    "16\\31",
    "17\\31",
    "18\\31",
    "19\\31",
    "20\\31",
    "21\\31",
    "22\\31",
    "23\\31",
    "24\\31",
    "25\\31",
    "26\\31",
    "27\\31",
    "28\\31",
    "29\\31",
    "30\\31",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "31edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "c",
    "c",
    "d",
    "d",
    "d",
    "d",
    "d",
    "e",
    "e",
    "e",
    "e",
    "e",
    "f",
    "f",
    "f",
    "g",
    "g",
    "g",
    "g",
    "g",
    "a",
    "a",
    "a",
    "a",
    "a",
    "b",
    "b",
    "b",
    "b",
    "b"
  ],
  "note_colors": [
    "#ffcccc",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3",
    "#e2dfcf",
    "#dddae2",
    "#f9f7eb",
    "#eff4e7",
    "#eee9d3"
  ],
  "equivSteps": 31,
  "fundamental": 440,
  "reference_degree": 23,
  "center_degree": 0,
  "rSteps": 5,
  "drSteps": 3,
  "hexSize": 42,
  "rotation": -16.102113751
}
